import React, { useEffect, useState } from "react";

import ProfileDropdown from "../Components/Common/ProfileDropdown";
import { Link } from "react-router-dom";
import KOTList from "../OrderingSystem/POS/KOT/page/KOTList";
import { getLoggedInUser } from "../helpers/fakebackend_helper";
import TableSelect from "../OrderingSystem/POS/page/Table/page/TableSelect";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const SecondaryHeader = ({
  data,
  sectionData,
  setSelectedSection,
  selectedSection,
  setSelectedTable,
  selectedTable,
  kotListRef,
  isTableOpen,
  setIsTableOpen,
  setKotList,
  kotList,
  allTables,
}) => {
  const authUser = getLoggedInUser();
  // console.log("authUserr", authUser);
  const userRole = authUser?.user?.roles[0]?.toLowerCase();
  useEffect(() => {
    const isMobile = window.innerWidth < 992; // Bootstrap lg breakpoint
    setIsTableOpen(isMobile); // Only open on small screens initially
  }, []);
  const [tableOpen, setTableOpen] = useState(false);
  const toggleTableModal = () => setTableOpen(!tableOpen);
  const [loading, setLoading] = useState(false);
  const [isKotOpen, setIsKotOpen] = useState(false);
  const toggleKotOpen = () => setIsKotOpen(!isKotOpen);

  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const confirmToggle = () => {
    setIsConfirmOpen(!isConfirmOpen);
  };
  return (
    <header className="bg-light sticky-top">
      <div
        className="w-100  d-flex justify-content-between align-items-center"
        style={{ height: "60px" }}
      >
        {/* Left: Hamburger + Logo */}
        <div className="d-flex align-items-center ">
          {/* <button
            onClick={toggleSidebar}
            type="button"
            className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn"
          >
            <span className="hamburger-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button> */}

          <span className="logo-sm">
            {/* <img src={logoSm} alt="" height="22" /> */}

            <img
              src={"/" + window.APP_CONFIG.tenent + "/restroorder.png"}
              alt=""
              height="35"
            />
          </span>
        </div>

        {/* Right: POS + Notification + Profile */}
        <div className="d-flex align-items-center gap-3">
          {userRole !== "waiter" ? (
            <>
              {/* <Link to="/dashboard"> */}
              <button
                className="btn btn-soft-dark btn-sm d-lg-block d-none"
                onClick={confirmToggle}
              >
                <i className="ri-tv-2-line"></i> Dashboard
              </button>
              {/* </Link> */}
              <Link to="/dashboard">
                <button className="btn btn-soft-dark btn-sm d-lg-none d-md-none d-block">
                  <i className="ri-tv-2-line"></i>
                </button>
              </Link>
            </>
          ) : null}
          <div
            className="d-flex d-lg-none align-items-center gap-2 cursor-pointer"
            onClick={toggleTableModal}
          >
            <i
              className="ri-restaurant-line fs-4 text-success"
              title="Select Table"
            ></i>
            <div>
              <h6 className="mb-0 fw-semibold">
                {selectedTable?.tableName || "Table"}
              </h6>
            </div>
          </div>
          <button
            className="btn btn-soft-success btn-sm d-lg-flex d-none  align-items-center gap-2 cursor-pointer px-3"
            onClick={toggleKotOpen}
          >
            <i class="ri-file-list-3-line fs-6"></i>

            <h6 className="mb-0 fw-semibold">KOT</h6>
          </button>
          {/* <button
            className="btn btn-soft-success btn-sm d-lg-none d-flex  align-items-center gap-2 cursor-pointer "
            onClick={toggleKotOpen}
          >
            <i class="ri-file-list-3-line fs-4"></i>

            <h6 className="mb-0 fw-semibold">KOT</h6>
          </button> */}
          {/* <NotificationDropdown /> */}
          <ProfileDropdown
            toggleKotOpen={toggleKotOpen}
            toggleTableModal={toggleTableModal}
          />
        </div>
      </div>
      <TableSelect
        isOpen={tableOpen}
        toggle={toggleTableModal}
        setSelectedTable={setSelectedTable}
        selectedTable={selectedTable}
        data={data}
        sectionData={sectionData}
        setSelectedSection={setSelectedSection}
        selectedSection={selectedSection}
        loading={loading}
        allTables={allTables}
      />
      <KOTList
        isOpen={isKotOpen}
        toggle={toggleKotOpen}
        ref={kotListRef}
        setSelectedTable={setSelectedTable}
        setKotList={setKotList}
        kotList={kotList}
      />

      <Modal isOpen={isConfirmOpen} toggle={confirmToggle}>
        <ModalHeader toggle={confirmToggle}></ModalHeader>
        <ModalBody>
          <div className="text-center">
            <i className="bi bi-exclamation-triangle-fill text-warning fs-1 mb-3"></i>
            <h5 className="fw-bold mb-2">
              Are you sure you want to leave this page?
            </h5>
            <p className="text-muted">
              You are about to leave this page and go to your dashboard. Do you
              want to continue?
            </p>
          </div>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button className="btn btn-outline-danger" onClick={confirmToggle}>
            <i className="bi bi-arrow-left"></i> Stay Here
          </button>
          <Link to="/dashboard">
            <button className="btn btn-success">
              <i className="bi bi-check-circle"></i> Yes, Go to Dashboard
            </button>
          </Link>
        </ModalFooter>
      </Modal>
    </header>
  );
};

export default SecondaryHeader;
